import { FC, useState, useEffect, useMemo } from 'react';

import { ITableMainProps } from './types';
import { RateCardChargesTableDeclaration } from './TableDeclaration';
import { RateCardChargesTableContainer } from './TableContainer';
import { RateCardChargesTableWeight } from './TableWeight';
import { RateCardChargesTableShipment } from './TableShipment';
import { RateCardChargesTablePercentage } from './TablePercentage';

export const RateCardChargesTableMain: FC<ITableMainProps> = ({
  tableRef,
  chargeCategory,
  contractFlow,
  filters,
  setFilters,
  sorting,
  setSorting,
  isAdmin,
}) => {
  // Add a refresh timestamp that changes when the charge category changes
  const [refreshTimestamp, setRefreshTimestamp] = useState<number>(Date.now());

  // Reset the refresh timestamp when charge category or contract changes
  useEffect(() => {
    setRefreshTimestamp(Date.now());
  }, [chargeCategory, contractFlow]);

  // Generate a unique table ID to force complete re-initialization
  const tableId = useMemo(() => `table-${chargeCategory}-${refreshTimestamp}`, [chargeCategory, refreshTimestamp]);

  const props = {
    tableRef,
    chargeCategory,
    contractFlow,
    refreshTimestamp,
    key: tableId, // Adding a key prop to force complete re-mounting of the component
    filters,
    setFilters,
    sorting,
    setSorting,
    isAdmin,
  };

  // Using key prop to force complete re-mounting when charge type or data changes
  if (chargeCategory === 'declarationCharges') {
    return <RateCardChargesTableDeclaration key={tableId} {...props} />;
  }
  if (chargeCategory === 'containerCharges') {
    return <RateCardChargesTableContainer key={tableId} {...props} />;
  }
  if (chargeCategory === 'weightCharges') {
    return <RateCardChargesTableWeight key={tableId} {...props} />;
  }
  if (chargeCategory === 'shipmentCharges') {
    return <RateCardChargesTableShipment key={tableId} {...props} />;
  }
  if (chargeCategory === 'percentageCharges') {
    return <RateCardChargesTablePercentage key={tableId} {...props} />;
  }
  return null;
};
